import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowDatePicker } from './datepicker.theme';

export const flowMobileDatePicker: Components<Theme>['MuiMobileDatePicker'] = {
  ...(flowDatePicker as Components<Theme>['MuiMobileDatePicker']),
  defaultProps: {
    ...(flowDatePicker.defaultProps as Components<Theme>['MuiMobileDatePicker']['defaultProps']),
    views: ['day', 'month', 'year'],
    // force portrait, landscape not supported
    orientation: 'portrait',
    slotProps: {
      ...(flowDatePicker.defaultProps
        ?.slotProps as Components<Theme>['MuiMobileDatePicker']['defaultProps']['slotProps']),
      dialog: {
        sx: {
          '& .MuiDialog-container': {
            alignItems: 'center',
          },
          '& .MuiDialog-paper': {
            borderRadius: '8px',
            maxWidth: '360px',
            height: 'auto',
            '&:has(.MuiPickersLayout-shortcuts)': {
              // shortcut size from datepicker.theme + size of calendar
              maxWidth: `${230 + 16 + 360}px`,
            },
          },
          '& .MuiDialogContent-root': {
            overflowX: 'hidden',
          },
        },
      },
    },
  },
};
